var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"showMessage"}},[(_vm.shown)?_c('div',{attrs:{"id":"message"}},_vm._l((_vm.messages),function(message,index){return _c('p',{key:`${message}-${index}`},[_vm._v("\n      "+_vm._s(message)+"\n    ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }